import '../index.css';

export default function Demo() {
  return (
    <section className="demo-section">
      <div className="section-inner">
        <p className="section-label">⚡USE A LOVABLE DE GRAÇA</p>
        <h2 className="section-title">Como Funciona na Prática</h2>
        
        <div className="demo-comparison">
          <div className="demo-side demo-before">
            <div className="demo-side-header">
              <span className="demo-icon">❌</span>
              <h3>SEM a Extensão</h3>
            </div>
            <ul className="demo-list">
              <li className="demo-item negative">
                <span className="item-icon">✕</span>
                <span>Paga $20/mês em dólar para a lovable por mês pra ter só 100 créditos</span>
              </li>
              <li className="demo-item negative">
                <span className="item-icon">✕</span>
                <span>Limite de créditos</span>
              </li>
              <li className="demo-item negative">
                <span className="item-icon">✕</span>
                <span>Projetos limitados</span>
              </li>
              <li className="demo-item negative">
                <span className="item-icon">✕</span>
                <span>Créditos acabam rápido</span>
              </li>
            </ul>
          </div>

          <div className="demo-divider">
            <span className="vs-badge">VS</span>
          </div>

          <div className="demo-side demo-after">
            <div className="demo-side-header">
              <span className="demo-icon">✓</span>
              <h3>COM Mestre Lovable Infinity</h3>
            </div>
            <ul className="demo-list">
              <li className="demo-item positive">
                <span className="item-icon">✓</span>
                <span><strong>Pagamento único</strong> em reais</span>
              </li>
              <li className="demo-item positive">
                <span className="item-icon">✓</span>
                <span><strong>Uso 100% ilimitado</strong></span>
              </li>
              <li className="demo-item positive">
                <span className="item-icon">✓</span>
                <span><strong>Crie projetos infinitos</strong></span>
              </li>
              <li className="demo-item positive">
                <span className="item-icon">✓</span>
                <span><strong>Sempre ativo, renova só se quiser</strong></span>
              </li>
            </ul>
          </div>
        </div>

        <div className="demo-steps">
          <h3 className="steps-title">🚀 Configure em 3 Passos Simples:</h3>
          <div className="steps-grid">
            <div className="step-card">
              <div className="step-number">1</div>
              <p className="step-text">Instale a extensão no navegador</p>
            </div>
            <div className="step-card">
              <div className="step-number">2</div>
              <p className="step-text">Ative sua chave de licença</p>
            </div>
            <div className="step-card">
              <div className="step-number">3</div>
              <p className="step-text">Use o Lovable ilimitado!</p>
            </div>
          </div>
        </div>
      </div>
    </section>);

}